// utils/cookies.ts
import Cookies from "js-cookie";

export const setVisitorCookie = () => {
  /* Visitor ID
  if (!Cookies.get("visitor_id")) {
    Cookies.set("visitor_id", crypto.randomUUID(), { expires: 365 });
  }*/

  // Language (optional default)
  if (!Cookies.get("lang")) {
    Cookies.set("lang", "en", { expires: 365 });
  }

  // Theme (optional default)
  if (!Cookies.get("theme")) {
    Cookies.set("theme", "light", { expires: 365 });
  }

  // Popup — first time only
  if (!Cookies.get("seen_popup")) {
    Cookies.set("seen_popup", "true", { expires: 7 }); // expires in 7 days
  }
};

